import React from "react";
//#region types
//#endregion
//#region components
import { useAccountingDonePermissions, useAccountingDoneUntil } from "components/accounting";
import { GridR } from "components/common";
import AccountingDone from "./accountingDone";
//#endregion

const AccountingDoneContainer: React.FC = (props) => {
  const { isAccountingCompletedInfoAvailable } = useAccountingDonePermissions();
  const { getCompanyAccountingDoneUntilMonth, companyAccountingDoneUntilMonth } = useAccountingDoneUntil();

  React.useEffect(() => {
    if (isAccountingCompletedInfoAvailable()) {
      getCompanyAccountingDoneUntilMonth();
    }
  }, []);

  return isAccountingCompletedInfoAvailable() && companyAccountingDoneUntilMonth !== undefined ? (
    <GridR item xs={12}>
      <AccountingDone accountingCompletedUntil={companyAccountingDoneUntilMonth} />
    </GridR>
  ) : (
    <></>
  );
};

export default AccountingDoneContainer;
